import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  Typography,
} from '@mui/material';
import JobDeliveryPhotos from './JobDeliveryPhotos';
import { googleMapsQueryUrl, formatJobDeliveryLine } from '../utils/jobMapsLink';

export default function CompletedJobDetailsDialog({
  open,
  job,
  onClose,
  isMobile = false,
  canAddPhotos = false,
  onJobUpdated = null,
}) {
  if (!job) return null;

  const address = formatJobDeliveryLine(job) || 'N/A';
  const completion = job.delivery_completion;

  const handlePhotosAdded = (updatedJob) => {
    if (onJobUpdated) onJobUpdated(updatedJob);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      fullScreen={isMobile}
      sx={{ '& .MuiDialog-paper': { m: { xs: 0, sm: 2 } } }}
    >
      <DialogTitle>
        Order Details {job.id ? `(${job.id.substring(0, 8)})` : ''}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 1 }}>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
            Delivery information
          </Typography>
          <Typography variant="body2" sx={{ mb: 0.5 }}>
            <strong>Location:</strong>{' '}
            {address !== 'N/A' ? (
              <Link
                href={googleMapsQueryUrl(address)}
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
              >
                {address}
              </Link>
            ) : (
              'N/A'
            )}
          </Typography>
          <Typography variant="body2" sx={{ mb: 0.5 }}>
            <strong>Requested:</strong>{' '}
            {job.diesel_quantity > 0 && `${job.diesel_quantity} gal Diesel`}
            {job.diesel_quantity > 0 && job.def_quantity > 0 && ' / '}
            {job.def_quantity > 0 && `${job.def_quantity} gal DEF`}
            {!job.diesel_quantity && !job.def_quantity && 'N/A'}
          </Typography>
          {(job.delivered_diesel > 0 || job.delivered_def > 0) && (
            <Typography variant="body2" sx={{ mb: 0.5 }}>
              <strong>Delivered:</strong>{' '}
              {job.delivered_diesel > 0 && `${job.delivered_diesel} gal Diesel`}
              {job.delivered_diesel > 0 && job.delivered_def > 0 && ' / '}
              {job.delivered_def > 0 && `${job.delivered_def} gal DEF`}
            </Typography>
          )}
          {job.driver_name && (
            <Typography variant="body2" sx={{ mb: 0.5 }}>
              <strong>Driver:</strong> {job.driver_name}
            </Typography>
          )}
          {job.completed_at && (
            <Typography variant="body2" sx={{ mb: 0.5 }}>
              <strong>Completed:</strong> {new Date(job.completed_at).toLocaleString()}
            </Typography>
          )}
          {job.delivery_notes && (
            <Typography variant="body2" sx={{ mb: 0.5 }}>
              <strong>Delivery notes:</strong> {job.delivery_notes}
            </Typography>
          )}

          {completion && (
            <Box sx={{ mt: 2 }}>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                Completion record
              </Typography>
              <Typography variant="body2" sx={{ mb: 0.5 }}>
                <strong>Diesel delivered:</strong> {completion.diesel_delivered || 0} gal
              </Typography>
              <Typography variant="body2" sx={{ mb: 0.5 }}>
                <strong>DEF delivered:</strong> {completion.def_delivered || 0} gal
              </Typography>
              {completion.completion_notes && (
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  <strong>Driver notes:</strong> {completion.completion_notes}
                </Typography>
              )}
            </Box>
          )}

          <JobDeliveryPhotos
            photos={completion?.photos}
            jobId={job.id}
            canAdd={canAddPhotos}
            onPhotosAdded={handlePhotosAdded}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
